import { ReloadOutlined } from '@ant-design/icons';
import { Badge, Button, Popover, Tooltip, theme } from 'antd';
import PropTypes from 'prop-types';
import { getHarnessStatus } from '../utils/harness';

const HarnessStatusIndicator = ({ fetching, onRetry, queryError, status, version }) => {
  const { token } = theme.useToken();
  const value = queryError
    ? { text: '状态暂时无法确认', color: 'warning' }
    : getHarnessStatus(status);
  const title = version ? `${value.text} · ${version}` : value.text;
  const colors = {
    success: token.colorSuccess,
    error: token.colorError,
    warning: token.colorWarning,
    processing: token.colorInfo,
  };
  const indicator = (
    <Badge
      aria-label={`实例状态：${value.text}`}
      color={colors[value.color] || token.colorTextDisabled}
      role="status"
      tabIndex={queryError ? undefined : 0}
    />
  );

  return queryError ? (
    <Popover
      placement="bottomRight"
      title={title}
      trigger="click"
      content={
        <Button
          aria-label="重试查询"
          disabled={fetching}
          icon={<ReloadOutlined />}
          onClick={onRetry}
          size="small"
        >
          重试查询
        </Button>
      }
    >
      <Button aria-label="查看状态提示" icon={indicator} size="small" type="text" />
    </Popover>
  ) : (
    <Tooltip placement="bottomRight" title={title} trigger={['hover', 'focus']}>
      {indicator}
    </Tooltip>
  );
};

HarnessStatusIndicator.propTypes = {
  fetching: PropTypes.bool,
  onRetry: PropTypes.func.isRequired,
  queryError: PropTypes.bool,
  status: PropTypes.string,
  version: PropTypes.string,
};

export default HarnessStatusIndicator;
